
const mutations = {
    setBasket(state, { items }) {
        state.basket = { items };
        state.basketLoaded = true;
    },
    setBasketState(state, basketState) {
        state.basketState = basketState;
    }
};

export default mutations;